/* Indigo Dreams — AI Shopping Concierge widget. */
(function () {
  'use strict';

  var root = document.getElementById('ai-concierge-root');
  if (!root) return;

  var ENDPOINT = root.dataset.endpoint;
  var GREETING = root.dataset.greeting || 'Welcome to Indigo Dreams. How may I help you today?';
  var SUGGESTIONS = (root.dataset.suggestions || '')
    .split('\n')
    .map(function (s) { return s.trim(); })
    .filter(Boolean);
  if (!ENDPOINT) return;

  var HISTORY_KEY = 'idc_messages_v1';
  var busy = false;

  function loadHistory() {
    try { return JSON.parse(sessionStorage.getItem(HISTORY_KEY)) || []; } catch (e) { return []; }
  }
  function saveHistory(h) {
    try { sessionStorage.setItem(HISTORY_KEY, JSON.stringify(h.slice(-30))); } catch (e) { /* noop */ }
  }
  var history = loadHistory();

  /* ---------- DOM ---------- */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  var chatIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M21 12c0 4.4-4 8-9 8-1.1 0-2.2-.2-3.2-.5L3 21l1.6-4.1C3.6 15.5 3 13.8 3 12c0-4.4 4-8 9-8s9 3.6 9 8z"/></svg>';
  var closeIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 4l16 16M20 4L4 20"/></svg>';

  var launcher = el('button', 'idc-launcher');
  launcher.type = 'button';
  launcher.setAttribute('aria-label', 'Open shopping concierge');
  launcher.innerHTML = chatIcon + '<span>Concierge</span>';

  var panel = el('div', 'idc-panel');
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Indigo Dreams shopping concierge');

  var header = el('div', 'idc-header');
  var titleWrap = el('div');
  titleWrap.appendChild(el('div', 'idc-title', 'Indigo Dreams'));
  titleWrap.appendChild(el('div', 'idc-subtitle', 'Personal shopping concierge'));
  var closeBtn = el('button', 'idc-close');
  closeBtn.type = 'button';
  closeBtn.setAttribute('aria-label', 'Close concierge');
  closeBtn.innerHTML = closeIcon;
  header.appendChild(titleWrap);
  header.appendChild(closeBtn);

  var messagesBox = el('div', 'idc-messages');
  messagesBox.setAttribute('aria-live', 'polite');

  var suggestionsBox = el('div', 'idc-suggestions');

  var inputRow = el('form', 'idc-inputrow');
  var input = el('input', 'idc-input');
  input.type = 'text';
  input.placeholder = 'Ask about a piece, an occasion, a fabric…';
  input.maxLength = 500;
  input.setAttribute('aria-label', 'Message the concierge');
  var sendBtn = el('button', 'idc-send', 'Send');
  sendBtn.type = 'submit';
  inputRow.appendChild(input);
  inputRow.appendChild(sendBtn);

  var disclaimer = el('div', 'idc-disclaimer', 'AI concierge. Please confirm final prices at checkout.');

  panel.appendChild(header);
  panel.appendChild(messagesBox);
  panel.appendChild(suggestionsBox);
  panel.appendChild(inputRow);
  panel.appendChild(disclaimer);
  root.appendChild(launcher);
  root.appendChild(panel);

  /* ---------- rendering ---------- */

  function scrollDown() { messagesBox.scrollTop = messagesBox.scrollHeight; }

  function addBubble(role, text, products) {
    var b = el('div', 'idc-msg ' + (role === 'user' ? 'idc-msg--user' : 'idc-msg--bot'));
    if (role !== 'user') {
      linkifyInto(b, text, products || []);
    } else {
      b.textContent = text;
    }
    messagesBox.appendChild(b);
    scrollDown();
    return b;
  }

  /* Turn product-name mentions and store paths (/pages/contact, /cart, …) in
     bot text into links with friendly labels (built with DOM nodes, never
     innerHTML, so the model's text is always treated as plain text). */
  function linkifyInto(node, text, products) {
    var matches = [];
    products.forEach(function (p) {
      if (!p.title || !p.url) return;
      var idx = text.toLowerCase().indexOf(p.title.toLowerCase());
      if (idx !== -1) matches.push({ start: idx, end: idx + p.title.length, url: p.url, label: null });
    });
    var re = /\/(?:pages|collections|products|policies)\/[a-z0-9\-_]+|\/cart\b/gi;
    var m;
    while ((m = re.exec(text))) {
      var path = m[0];
      var label = path === '/cart'
        ? 'your bag'
        : path.split('/').pop().replace(/[-_]/g, ' ');
      matches.push({ start: m.index, end: m.index + path.length, url: path, label: label });
    }
    matches.sort(function (a, b) { return a.start - b.start; });
    var pos = 0;
    matches.forEach(function (mt) {
      if (mt.start < pos) return; // overlapping match — skip
      node.appendChild(document.createTextNode(text.slice(pos, mt.start)));
      var a = el('a', 'idc-inline-link', mt.label || text.slice(mt.start, mt.end));
      a.href = mt.url;
      node.appendChild(a);
      pos = mt.end;
    });
    node.appendChild(document.createTextNode(text.slice(pos)));
  }

  function formatPrice(price) {
    if (!price || price.amount == null) return '';
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: price.currency || 'INR',
        maximumFractionDigits: 0
      }).format(price.amount / 100);
    } catch (e) {
      return '';
    }
  }

  function addProducts(products) {
    if (!products || !products.length) return;
    var row = el('div', 'idc-products');
    products.forEach(function (p) {
      var card = el('a', 'idc-card');
      card.href = p.url;
      if (p.image) {
        var img = document.createElement('img');
        img.src = p.image;
        img.alt = p.title;
        img.addEventListener('load', scrollDown); // images grow the list after render
        card.appendChild(img);
      }
      var body = el('div', 'idc-card-body');
      body.appendChild(el('div', 'idc-card-title', p.title));
      var priceText = formatPrice(p.price);
      if (priceText) body.appendChild(el('div', 'idc-card-price', priceText));
      body.appendChild(el('span', 'idc-card-cta', p.available === false ? 'Sold out' : 'View'));
      card.appendChild(body);
      row.appendChild(card);
    });
    messagesBox.appendChild(row);
    scrollDown();
  }

  /* Fetch the theme cart — the single source of truth the agent reasons over. */
  function fetchBag() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return {
          items: (cart.items || []).map(function (i) {
            return {
              title: i.product_title,
              variant_title: i.variant_title,
              variant_id: i.variant_id,
              quantity: i.quantity,
              price: i.price
            };
          }),
          total_price: cart.total_price
        };
      })
      .catch(function () { return null; });
  }

  /* "View bag" link + a real Shopify checkout button. Razorpay Magic Checkout
     intercepts button[name="checkout"] clicks exactly as it does on the cart
     page and Buy-it-now; if Razorpay is inactive, the form falls back to the
     store's regular checkout. */
  function addBagActions() {
    var wrap = el('div', 'idc-bagactions');
    var view = el('a', 'idc-cart-link', 'View bag');
    view.href = '/cart';
    var form = document.createElement('form');
    form.action = '/cart';
    form.method = 'post';
    var btn = el('button', 'idc-cart-link idc-checkout-btn', 'Checkout');
    btn.type = 'submit';
    btn.name = 'checkout';
    form.appendChild(btn);
    wrap.appendChild(view);
    wrap.appendChild(form);
    messagesBox.appendChild(wrap);
    scrollDown();
  }

  /* Mirror agent-added items into the theme's own cart so checkout flows
     through the store's normal path (Razorpay Magic Checkout), not
     Shopify's headless-cart checkout. */
  function mirrorToThemeCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items.map(function (i) {
          return { id: Number(i.variant_id), quantity: i.quantity || 1 };
        })
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart add failed');
      addBagActions();
    });
  }

  function renderSuggestions() {
    suggestionsBox.innerHTML = '';
    if (history.length || !SUGGESTIONS.length) return;
    SUGGESTIONS.slice(0, 4).forEach(function (s) {
      var chip = el('button', 'idc-chip', s);
      chip.type = 'button';
      chip.addEventListener('click', function () { send(s); });
      suggestionsBox.appendChild(chip);
    });
  }

  /* ---------- conversation ---------- */

  var MSG_CAP = 40; // per-session backstop, far beyond genuine conversations

  function send(text) {
    text = (text || '').trim();
    if (!text || busy) return;
    var count = 0;
    try { count = Number(sessionStorage.getItem('idc_msg_count') || 0); } catch (e) { /* noop */ }
    if (count >= MSG_CAP) {
      addBubble('assistant', "We've covered a lot in this conversation. For anything further, our team at /pages/contact-us would love to help you personally.");
      return;
    }
    try { sessionStorage.setItem('idc_msg_count', String(count + 1)); } catch (e) { /* noop */ }
    busy = true;
    sendBtn.disabled = true;
    input.value = '';
    suggestionsBox.innerHTML = '';

    addBubble('user', text);
    history.push({ role: 'user', content: text });
    saveHistory(history);

    var typing = el('div', 'idc-typing');
    typing.innerHTML = '<span></span><span></span><span></span>';
    messagesBox.appendChild(typing);
    scrollDown();

    fetchBag().then(function (bag) {
      return fetch(ENDPOINT.replace(/\/$/, '') + '/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: history.slice(-16), bag: bag })
      });
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (r) {
        typing.remove();
        // rate-limited responses carry a friendly reply — show it in the
        // concierge's voice rather than the generic failure message
        if (r.data && r.data.rate_limited && r.data.reply) {
          addBubble('assistant', r.data.reply);
          return;
        }
        if (!r.ok || r.data.error) throw new Error(r.data.error || 'Request failed');
        addBubble('assistant', r.data.reply, r.data.products);
        history.push({ role: 'assistant', content: r.data.reply });
        saveHistory(history);
        addProducts(r.data.products);
        if (r.data.added_items && r.data.added_items.length) {
          mirrorToThemeCart(r.data.added_items).catch(function () {
            addBubble('assistant', 'I had trouble placing that in your bag — you can add it from the product page.');
          });
        }
      })
      .catch(function () {
        typing.remove();
        addBubble('assistant', 'I could not reach the concierge just now. Please try again in a moment.');
      })
      .finally(function () {
        busy = false;
        sendBtn.disabled = false;
        input.focus();
      });
  }

  /* ---------- open / close ---------- */

  function openPanel() {
    panel.classList.add('idc-open');
    launcher.style.display = 'none';
    if (!messagesBox.childElementCount) {
      addBubble('assistant', GREETING);
      renderSuggestions();
      history.forEach(function (m) { addBubble(m.role, m.content); });
    }
    input.focus();
  }
  function closePanel() {
    panel.classList.remove('idc-open');
    launcher.style.display = '';
    launcher.focus();
  }

  launcher.addEventListener('click', openPanel);
  closeBtn.addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('idc-open')) closePanel();
  });
  inputRow.addEventListener('submit', function (e) {
    e.preventDefault();
    send(input.value);
  });
})();
